import React from "react";
import "../App.css";

const SkeletonTable = () => {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default SkeletonTable;
